import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { TID } from "../../lib/testIds";

export function ArticleCard({ article, featured = false }) {
  return (
    <Link
      to={`/articles/${article.slug}`}
      data-testid={
        featured ? TID.featuredArticleCard(article.slug) : TID.articleCard(article.slug)
      }
      className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-200 hover:-translate-y-[2px] hover:border-emerald-300 hover:shadow-lg sm:p-7"
    >
      <div className="flex items-center gap-2">
        <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-emerald-700">
          {article.category.replace("-", " ")}
        </span>
        <span className="text-slate-300">•</span>
        <span className="inline-flex items-center gap-1 text-xs text-slate-500">
          <Clock className="h-3 w-3" /> {article.read_time} min read
        </span>
      </div>
      <h3 className="mt-3 text-xl font-bold tracking-tight text-slate-900 transition-colors group-hover:text-emerald-800">
        {article.title}
      </h3>
      <p className="mt-2 flex-1 text-sm text-slate-600">{article.excerpt}</p>
      <span className="mt-5 inline-flex items-center text-sm font-medium text-emerald-700">
        Read article →
      </span>
    </Link>
  );
}
